.content {
	z-index: var(--z-overlay);
	max-inline-size: 18rem;
	padding: var(--spacing-2) var(--spacing-3);
	font-size: var(--font-size-sm);
	line-height: var(--line-height-base);
	color: var(--colour-background-page);
	background-color: var(--colour-text-primary);
	border-radius: var(--radius-sm);
	box-shadow: var(--shadow-sm);
	animation: pop-in var(--motion-fast) var(--ease-standard);
}

.arrow {
	fill: var(--colour-text-primary);
}

@keyframes pop-in {
	from {
		opacity: 0;
		transform: scale(0.96);
	}
}

@media (prefers-reduced-motion: reduce) {
	.content {
		animation: none;
	}
}
